<mat-form-field class="example-chip-list" appearance="fill">
  <mat-label>Related Parts</mat-label>
  <mat-chip-list #chipList aria-label="Tags">
    <mat-chip
      *ngFor="let product of products"
      (removed)="remove(product)">
      <div class="related-products-chip-item">
        <span><b>SKU: </b>{{product.sku}}</span>
        <small><b>Product ID: </b>{{product.product_id}}</small>
      </div>
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
  </mat-chip-list>
</mat-form-field>
<br>
<mat-menu class="primary" #skuFilterObsolete="matMenu">
  <button [disabled]="currentFilter === 'Contains'" (click)="changeFilterType('Contains')" mat-menu-item>Contains</button>
  <button [disabled]="currentFilter === 'Equals'" (click)="changeFilterType('Equals')" mat-menu-item>Equals</button>
</mat-menu>
<div style="position: relative;">
  <mat-form-field>
    <button [matMenuTriggerFor]="skuFilterObsolete" mat-icon-button class="sku-obsolete-filter-btn">
      <mat-icon>filter_list</mat-icon>
    </button>
    <input type="text" #skuSearch placeholder="Type SKU for search...  ({{currentFilter}})" (input)="onChange($event)" matInput [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option [disabled]="checkExist(option.product_id)" *ngFor="let option of filteredOptions | async" data-id="option._id" [value]="option">
        {{option.sku}} ({{option.product_id}})
        <span style="font-size: 13px;font-weight: 300;">{{option.brand.name}}</span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>

<br>
<div class="btn-bottom-area">
  <button (click)="save()" mat-raised-button color="primary">Save</button>
  <button (click)="cancel()" mat-raised-button color="warn">Cancel</button>
</div>
